<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-view">
      
    <vs-tabs>
    <vs-tab  label="Marcar Entrada" icon-pack="feather" icon="icon-log-in">
        <Entrada/>
        

    </vs-tab>
    <vs-tab  label="Marcar Saida" icon-pack="feather" icon="icon-log-out">
       <Saida/>
    </vs-tab>

     <vs-tab label="Visualizar" icon-pack="feather" icon="icon-eye">
       <PresencasList/>
    </vs-tab>
   
  </vs-tabs>


   
  </div>
</template>

<script>
import vSelect from 'vue-select'
import Entrada from './Entrada.vue'
import Saida from './Saida.vue'
import PresencasList from './PresencasList.vue'
import { PermissionsMixin } from '../../../mixins/permissions'

export default {
  mixins:[PermissionsMixin],
    components: {
      Entrada,
      Saida,
      PresencasList,
    vSelect
  },
  data() {
    return {
     
     
   


    
      

    }
  },

  
  mounted(){
    this.verifyPermissions();
  },


  methods: {
  






   

  
},


}

</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }

}

</style>
